import { useMutation } from '@apollo/react-hooks'
import {
  UpdateMarketplaceListingMutation,
  UpdateMarketplaceListingMutationVariables
} from './__generated__/UpdateMarketplaceListingMutation'
import { gql } from 'apollo-boost'
import {
  UpdateMarketplaceListingPropsMutation,
  UpdateMarketplaceListingPropsMutationVariables
} from './__generated__/UpdateMarketplaceListingPropsMutation'
import {
  UpdateMarketplaceListingCadencePolicyMutation,
  UpdateMarketplaceListingCadencePolicyMutationVariables
} from './__generated__/UpdateMarketplaceListingCadencePolicyMutation'

const MUTATION = gql`
  mutation UpdateMarketplaceListingMutation($input: UpdateMarketplaceListingInput!) {
    updateMarketplaceListing(input: $input) {
      id
    }
  }
`

const PROPS_MUTATION = gql`
  mutation UpdateMarketplaceListingPropsMutation($input: UpdateMarketplaceListingPropsInputV2!) {
    updateMarketplaceListingPropsV2(input: $input) {
      ... on MarketplaceListingPropsV2 {
        marketplaceListingId
        propsJson
      }
      ... on MarketplaceListingErrorV2 {
        type
        error
      }
    }
  }
`

const CADENCE_POLICY_MUTATION = gql`
  mutation UpdateMarketplaceListingCadencePolicyMutation(
    $input: UpdateMarketplaceListingCadencePolicyInputV2!
  ) {
    updateMarketplaceListingCadencePolicyV2(input: $input) {
      ... on MarketplaceListingCadencePolicyV2 {
        marketplaceListingId
        policyJson
      }
      ... on MarketplaceListingErrorV2 {
        type
        error
      }
    }
  }
`

export const useUpdateMarketplaceListing = () =>
  useMutation<UpdateMarketplaceListingMutation, UpdateMarketplaceListingMutationVariables>(MUTATION)

export const useUpdateMarketplaceListingProps = () =>
  useMutation<UpdateMarketplaceListingPropsMutation, UpdateMarketplaceListingPropsMutationVariables>(PROPS_MUTATION)

export const useUpdateMarketplaceListingCadencePolicy = () =>
  useMutation<
    UpdateMarketplaceListingCadencePolicyMutation,
    UpdateMarketplaceListingCadencePolicyMutationVariables
  >(CADENCE_POLICY_MUTATION)
